import React, { Component } from 'react'
import { connect } from 'react-redux'
import IPropTypes from 'react-immutable-proptypes'
import { Map } from 'immutable'

import { exportsInitLoad } from './actions'

const mapStateToProps = (state) => ({
    jobs: state.getIn(['ui', 'entityStack', 'exports', 'jobs'], Map()),
    loaded: state.getIn(['ui', 'entityStack', 'exports', 'loaded'], false),
    loading: state.getIn(['ui', 'entityStack', 'exports', 'loading'], false),
})

const actions = {
    exportsInitLoad,
}

export default (InnerComponent) => {
    @connect(mapStateToProps, actions)
    class HocConnect extends Component {
        static propTypes = {
            jobs: IPropTypes.map.isRequired,
        }

        render() {
            return <InnerComponent {...this.props} />
        }
    }

    return HocConnect
}
